import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.addFuelexpenses = (fuelExpenses) => {
  fuelExpenses = Object.assign({}, fuelExpenses);
  const promises = [];
  return http
    .post("/fuel-expense/create", {
      cityId: fuelExpenses.cityId,
      vehicleId: fuelExpenses.vehicleId,
      driverId: fuelExpenses.driverId,
      disel: fuelExpenses.disel,
      amount: fuelExpenses.amount,
      receipt: fuelExpenses.receipt,
    })
    .then((result) => {
      fuelExpenses = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("fuelExpenses.create-error:\n", error);
      throw error;
    });
};

internals.getDrivers = (Id) => {
  return http
    .get(`/register/driver/list?cityId=${Id}`)
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      console.error("fuelExpenses.create-error:\n", error);
      throw error;
    });
};

internals.updateFuelexpenses = (_id, fuelExpenses) => {
  return http
    .put(`/fuel-expense/update`, {
      _id: fuelExpenses._id,
      cityId: fuelExpenses.cityId,
      vehicleId: fuelExpenses.vehicleId,
      driverId: fuelExpenses.driverId,
      disel: fuelExpenses.disel,
      amount: fuelExpenses.amount,
      receipt: fuelExpenses.receipt,
      status: fuelExpenses.status,
    })
    .then((result) => {
      fuelExpenses = result.data;
      return fuelExpenses;
    })
    .catch((error) => {
      console.error("fuelExpenses.updateVehicle-error:\n", error);
      throw error;
    });
};

internals.deleteFuelexpenses = (_id) => {
  return http
    .delete(`/fuel-expense/delete?_id=` + _id)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("fuelExpenses.delete-error:\n", error);
      throw error;
    });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/fuelexpenses.service.js